import { COLORS } from '@color-dots/game';

// Kept in sync with CanvasRenderer.ts's COLOR_LIGHT — same 2026-09-16 fix
// (c6 moved away from red, c9/c10 added so expert-pack 9-10 pair levels
// don't fall back to a flat gray in 3D mode either).
export const COLOR_LIGHT_3D: Record<string, string> = {
  c1: '#FCA5A5',
  c2: '#93C5FD',
  c3: '#86EFAC',
  c4: '#FCD34D',
  c5: '#D8B4FE',
  c6: '#F2A6DE',
  c7: '#5EEAD4',
  c8: '#BEF264',
  c9: '#F9B494',
  c10: '#C5C2FA',
};

export function getColorHex(colorId: string): string {
  return COLORS[colorId] ?? '#888888';
}

export function getColorLight(colorId: string): string {
  return COLOR_LIGHT_3D[colorId] ?? getColorHex(colorId);
}

/** Gear endpoint torus rim colors per §8.2. */
export const GEAR_RIM_COLORS: Record<string, string> = {
  c1: '#8a6a3a',
  c2: '#4a6a9a',
  c3: '#c4a070',
  c4: '#9090a0',
  c5: '#8a6a3a',
  c6: '#b87333',
};

export const GEAR_RIM_ACCENT_COLORS: Record<string, string | undefined> = {
  c2: '#2563eb',
  c5: '#9333ea',
  c6: '#c4a070',
};

export function getGearRimColor(colorId: string): string {
  return GEAR_RIM_COLORS[colorId] ?? '#8a6a3a';
}

export function getGearRimAccent(colorId: string): string | undefined {
  return GEAR_RIM_ACCENT_COLORS[colorId];
}
